import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#F59E0B', '#3B82F6', '#10B981', '#EF4444', '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'];

const SupplierAnalysis = ({ data }) => {
    if (!data || !data.top_suppliers || data.top_suppliers.length === 0) return null;

    const labels = data.top_suppliers.map(s => s.supplier_name);
    const values = data.top_suppliers.map(s => s.total_spend);
    const colors = labels.map((_, i) => COLORS[i % COLORS.length]);

    const chartData = {
        labels,
        datasets: [{
            label: 'Spend (BHD)',
            data: values,
            backgroundColor: colors,
            borderRadius: 4,
        }],
    };

    const options = {
        responsive: true,
        indexAxis: 'y',
        plugins: {
            legend: { display: false },
        },
        scales: {
            x: {
                title: { display: true, text: 'Spend (BHD)' },
            },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Supplier Spend Analysis</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total Spend</small>
                            <strong>{data.total_spend?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Suppliers</small>
                            <strong>{data.supplier_count}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Invoices</small>
                            <strong>{data.total_invoices}</strong>
                        </div>
                    </div>
                </div>
                <Bar data={chartData} options={options} />
                <div className="table-responsive mt-3">
                    <table className="table table-sm table-bordered mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Supplier</th>
                                <th className="text-end">Spend</th>
                                <th className="text-end">Invoices</th>
                                <th className="text-end">%</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.top_suppliers.map((s, i) => (
                                <tr key={i}>
                                    <td>{s.supplier_name}</td>
                                    <td className="text-end">{s.total_spend?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                    <td className="text-end">{s.invoice_count}</td>
                                    <td className="text-end">{s.percentage}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default SupplierAnalysis;
